import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=6ab752d0&scoped=true"
import script from "./CategoryGrid.vue?vue&type=script&lang=ts"
export * from "./CategoryGrid.vue?vue&type=script&lang=ts"
import style0 from "./CategoryGrid.vue?vue&type=style&index=0&id=6ab752d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab752d0",
  null
  
)

export default component.exports